import Drawer from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const BOTTOM_NAV_HEIGHT = 250;

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: prop => prop !== 'open',
})<{ open: boolean; width: number }>(({ theme, open, width }) => ({
  position: 'relative',
  zIndex: 1200,
  width,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen / 2,
  }),
  overflowX: open ? 'visible' : 'hidden',
  '& .MuiDrawer-paper': {
    width,
    overflowX: open ? 'visible' : 'hidden',
    backgroundColor: theme.palette.primary.main,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen / 2,
    }),
  },
}));

const DrawerContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: 0,
  position: 'relative',
});

const DrawerTop = styled('div')({});

const DrawerBottom = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  overflow: 'hidden',
  rowGap: theme.spacing(2),
}));

const SidebarTop = styled('div')({
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
});

const SidebarBottom = styled('div')(({ theme }) => ({
  background: `linear-gradient(0deg, ${theme.palette.primary.dark} -50%, ${theme.palette.primary.main} 100%)`,
  zIndex: 1000,
  maxHeight: BOTTOM_NAV_HEIGHT,
}));

const LogoContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  minHeight: `${theme.toolbarHeight}px`,
  alignItems: 'center',
  justifyContent: 'center',
}));

const ToggleButton = styled('button')({
  position: 'fixed',
  bottom: '20px',
  left: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  width: '40px',
  height: '40px',
});

const ButtonReset = styled('div')({
  background: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  font: 'inherit',
  textAlign: 'inherit',
  width: '100%',
});

export {
  SidebarBottom,
  ButtonReset,
  DrawerBottom,
  DrawerContainer,
  DrawerTop,
  LogoContainer,
  SidebarTop,
  StyledDrawer,
  ToggleButton,
};
